/* OFFRE STICKERS « 2e -30 % · 3e -50 % · 4e offert » — tiroir panier
   Maison Stickers Muraux

   Appelé par le panier custom (footer-group, « Panier drawer ») juste après
   chaque rendu : window.msmOffre.drawer(mount, cart), cart = réponse de /cart.js.
   Ajoute la barre de progression de l'offre et, sous chaque article, le libellé
   de la remise reçue (« 2e sticker -30 % »…), tel que calculé par Shopify.
   Les textes viennent du snippet msm-offre (mode js), dans la langue du site.

   Hors offre : produits sans le tag « stickers ». /cart.js ne donne pas les
   tags, d'où la liste des handles concernés ci-dessous. Un nouveau produit
   hors sticker (accessoire, carte cadeau…) doit y être ajouté. */
(function () {
  var C = window.msmOffre = window.msmOffre || {};
  var T = C.txt || {};
  var HORS_OFFRE = ['commande-prioritaire', 'shipping-insurance'];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function ord(n) {
    if (C.lang === 'en') {
      var m100 = n % 100, m10 = n % 10, suf = 'th';
      if (m100 < 11 || m100 > 13) suf = m10 === 1 ? 'st' : m10 === 2 ? 'nd' : m10 === 3 ? 'rd' : 'th';
      return n + suf;
    }
    if (C.lang === 'de') return n + '.';
    if (C.lang === 'it') return n + '°';
    return n === 1 ? '1er' : n + 'e';
  }

  function estSticker(it) {
    return !it.gift_card && HORS_OFFRE.indexOf(it.handle) === -1;
  }

  function nbStickers(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (estSticker(it)) n += it.quantity; });
    return n;
  }

  var STK_BG = ['#7C8B6F', '#B97F63', '#A8603F'];

  function barre(n) {
    var r = n % 4, fill = r === 0 ? 4 : r, lit = fill - 1, tpl, k;
    if (r === 0) { tpl = T.done; k = n; }
    else { tpl = r === 1 ? T.add30 : r === 2 ? T.add50 : T.addfree; k = n + 1; }
    var I = C.img || {}, html = '<div class="msm-em msm-em--cart msm-em--drawer' + (r === 0 ? ' is-done' : '') + '" role="status">';
    if (I.tape) html += '<img class="msm-em__tape" src="' + esc(I.tape) + '" alt="" width="86" height="27">';
    html += '<div class="msm-em__card"><div class="msm-em__in">' +
      '<p class="msm-em__kick">' + esc(T.kick || '') + '</p>' +
      '<p class="msm-em__msg">' + esc(String(tpl || '').replace('{n}', ord(k))) + '</p>' +
      '<div class="msm-em__row">';
    (T.stk || []).forEach(function (s, i) {
      var img = I.stk && I.stk[i] ? ';background-image:url(' + I.stk[i] + ')' : '';
      html += '<span class="msm-em__stk' + (i < lit ? ' is-on' : '') + '" style="background-color:' + STK_BG[i] + img + '">' +
        '<i>' + esc(s[0]) + '</i><b>' + esc(s[1]) + '</b></span>';
    });
    html += '</div><p class="msm-em__note">' + esc(T.note || '') + '</p></div></div></div>';
    return html;
  }

  C.drawer = function (mount, cart) {
    if (!mount || !cart || !cart.items) return;
    var n = nbStickers(cart);
    if (n > 0 && !mount.querySelector('.msm-em--drawer')) {
      var ship = mount.querySelector('.msm-cart__ship');
      var wrap = document.createElement('div');
      wrap.innerHTML = barre(n);
      if (ship) ship.parentNode.insertBefore(wrap.firstChild, ship);
    }
    var parCle = {};
    cart.items.forEach(function (it) { parCle[it.key] = it; });
    mount.querySelectorAll('.msm-cart__item[data-key]').forEach(function (row) {
      var it = parCle[row.getAttribute('data-key')];
      var allocs = ((it && it.line_level_discount_allocations) || []).filter(function (a) { return a.amount > 0; });
      if (!allocs.length || row.querySelector('.msm-of-lab')) return;
      var name = row.querySelector('.msm-cart__itemname');
      if (!name) return;
      var box = document.createElement('p');
      box.className = 'msm-of-labs';
      box.innerHTML = allocs.map(function (a) {
        var titre = a.discount_application && a.discount_application.title;
        return titre ? '<span class="msm-of-lab">' + esc(titre) + '</span>' : '';
      }).join('');
      name.parentNode.insertBefore(box, name.nextSibling);
    });
    confiance(mount);
  };

  /* Réassurances v2 (27/10/2026) : trois lignes lisibles juste au-dessus de « Commander »,
     à la place de la petite ligne grise sous le bouton (.msm-cart__trust, masquée dans msm-offre.css).
     Note et nombre d'avis : mêmes chiffres que l'en-tête et les fiches, à mettre à jour avec eux. */
  var CONFIANCE = {
    fr: ['Abîmé ou ne tient pas au mur ? Remplacé ou remboursé, retour à nos frais', '4,7/5 · 857 avis', 'Paiement sécurisé · Suivi de colis inclus'],
    en: ['Damaged or won’t stay on the wall? Replaced or refunded, return at our cost', '4.7/5 · 857 reviews', 'Secure checkout · Parcel tracking included'],
    de: ['Beschädigt oder hält nicht an der Wand? Ersatz oder Erstattung, Rücksendung auf unsere Kosten', '4,7/5 · 857 Bewertungen', 'Sichere Bezahlung · Sendungsverfolgung inklusive'],
    it: ['Danneggiato o non resta attaccato al muro? Sostituito o rimborsato, reso a nostre spese', '4,7/5 · 857 recensioni', 'Pagamento sicuro · Tracciamento del pacco incluso']
  };

  function confiance(mount) {
    var btn = mount.querySelector('.msm-cart__checkout');
    if (!btn || mount.querySelector('.msm-trust2')) return;
    var t = CONFIANCE[C.lang] || CONFIANCE.fr;
    var ul = document.createElement('ul');
    ul.className = 'msm-trust2';
    ul.innerHTML =
      '<li class="msm-trust2__g">' + esc(t[0]) + '</li>' +
      '<li class="msm-trust2__a"><span class="msm-trust2__etoiles" aria-hidden="true"><span></span></span>' + esc(t[1]) + '</li>' +
      '<li class="msm-trust2__p">' + esc(t[2]) + '</li>';
    btn.parentNode.insertBefore(ul, btn);
  }
})();
